<div class="modern-date-time-picker" [class.filled]="isFilled()">
  <div class="picker-trigger" (click)="onTriggerClick($event)">
    <img class="picker-icon" src="assets/images/common/date.svg" alt="date" />

    @if (!dateValue) {
      <div class="picker-placeholder">
        {{ label | labelsProvider }}
      </div>
    }

    @if (dateValue) {
      <div class="picker-value">
        {{ displayValue }}
      </div>
    }

    <div class="picker-icons">
      @if (dateValue) {
        <img class="picker-clear" src="assets/images/common/cancel.svg" (click)="clearDate($event)" alt="clear" />
      }
      <img src="assets/images/arrows/empty-arrow-down.svg" class="picker-dropdown" alt="expand" />
    </div>
  </div>

  <p-calendar
    #calendar
    [(ngModel)]="dateValue"
    (ngModelChange)="onDateChange($event)"
    [showTime]="true"
    hourFormat="24"
    [showIcon]="false"
    [minDate]="minDate"
    [maxDate]="maxDate || endOfToday()"
    [readonlyInput]="true"
    [stepMinute]="1"
    dateFormat="M d, yy"
    [showButtonBar]="false"
    (onSelect)="onDateSelect($event)"
    (onClear)="clearDate($event)"
    appendTo="body"
    inputId="date-picker-input"
  />
</div>
